
import React, { useState } from 'react';
import { ThumbsUp, CheckCircle, UserCheck } from 'lucide-react';
import { useAuth } from '../../auth/AuthContext';
import { PortalProfile } from '../../../core/types/portal';
import { vouchForTenant } from '../services/portalService';

interface CommunityVouchButtonProps {
  tenantId: string;
  businessName: string;
  portalProfile: PortalProfile;
  className?: string;
}

export const CommunityVouchButton: React.FC<CommunityVouchButtonProps> = ({
  tenantId,
  businessName,
  portalProfile,
  className = ''
}) => {
  const { user } = useAuth();
  const [vouched, setVouched] = useState(
    user ? portalProfile.communityVouches?.includes(user.uid) : false
  );
  const [count, setCount] = useState(portalProfile.communityVouches?.length || 0);
  const [loading, setLoading] = useState(false);

  const handleVouch = async () => {
    if (!user) {
      alert('Você precisa estar logado para validar uma empresa!');
      // TODO: Redirect to login
      return;
    }

    if (vouched) return;

    setLoading(true);

    try {
      const success = await vouchForTenant(tenantId, user.uid);
      
      if (success) {
        setVouched(true);
        setCount(prev => prev + 1);
        
        // Optimistic UI feedback
        // alert(`Obrigado! Sua confirmação ajuda a validar a ${businessName} para toda a comunidade.`);
      }
    } catch (error) {
      console.error('Error vouching:', error);
    } finally {
      setLoading(false);
    }
  };

  if (vouched) {
    return (
      <div className={`flex items-center gap-2 text-green-600 bg-green-50 px-4 py-2 rounded-full border border-green-200 ${className}`}>
        <CheckCircle size={18} className="fill-green-100" />
        <span className="font-bold text-sm">Você validou esta empresa</span>
      </div>
    );
  }

  return (
    <button
      onClick={handleVouch}
      disabled={loading}
      className={`group flex items-center gap-2 bg-white hover:bg-brand-blue/10 border border-brand-blue/20 text-brand-blue px-4 py-2 rounded-full transition-all hover:shadow-md active:scale-95 ${className}`}
      title="Você conhece esta empresa? Ajude a comunidade confirmando que ela existe e é confiável."
    >
      <div className={`bg-brand-blue/10 p-1.5 rounded-full group-hover:bg-brand-blue group-hover:text-white transition-colors ${loading ? 'animate-pulse' : ''}`}>
        <UserCheck size={16} />
      </div>
      <div className="text-left leading-tight">
        <div className="font-bold text-sm">Eu conheço</div>
        <div className="text-[10px] text-gray-500 font-medium">
          {count > 0 ? `${count} confirmações` : 'Seja o primeiro'}
        </div>
      </div>
    </button>
  );
};
